import React, { useEffect, useState } from 'react';
import { Navigate,useNavigate } from 'react-router-dom';
import EmployeeProcessService from '../services/EmployeeProcessService';
import { toast } from 'react-toastify';
import { useLoading } from '../Utils/LoadingContext';
import showToast from "../Utils/ToastContainer";

function EmployeeUpdate() {
  
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
    }
  }, []);
  const initialFormState = {
    employeeid:'',
    companyName: '',
    firstName: '',
    middleName: '',
    surname: '',
    dateOfJoining: '',
    dateOfBirth: '',
    employeeType: '',
    branch: '',
    designation: '',
    department: '',
    location: '',
    shiftTime: '',
    probation: '',
    grade: '',
    aadharCardNo: '',
    panNumber: '',
    voterId: '',
    aadharName: '',
    mobileNumber: '',
    address: ''
  };
  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});
  const [searchId, setSearchId] = useState('');
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  const validate = () => {
    const newErrors = {};
    if (!formData.companyName) newErrors.companyName = 'Required';
    if (!formData.firstName) newErrors.firstName = 'Required';
    if (!formData.dateOfJoining) newErrors.dateOfJoining = 'Required';
    if (!formData.designation) newErrors.designation = 'Required';
    return newErrors;
  };
  const normalizeData = (data) => ({
    employeeid: data.employeeid || '',
    companyName: data.companyName?.trim() || '',
    firstName: data.firstName || '',
    middleName: data.middleName || '',
    surname: data.surname || '',
    dateOfJoining: data.dateOfJoining?.slice(0, 10) || '', // date format
    dateOfBirth: data.dateOfBirth?.slice(0, 10) || '',
    employeeType: data.employeeType?.trim() || '',
    branch: data.branch?.trim() || '',
    designation: data.designation?.trim() || '',
    department: data.department?.trim() || '',
    location: data.location?.trim() || '',
    shiftTime: data.shiftTime?.trim() || '',
    probation: data.probation?.trim() || '',
    grade: data.grade?.trim() || '',
    aadharCardNo: data.aadharCardNo || '',
    panNumber: data.panNumber || '',
    voterId: data.voterId || '',
    aadharName: data.aadharName || '',
    mobileNumber: data.mobileNumber || '',
    address: data.address || ''
  });
  const handleSearch = async () => {
    if (!searchId) {
      toast.warning("Please enter an Employee ID");
      return;
    }

    try {
      setLoading(true);
      const response = await EmployeeProcessService.getEmployeeData(searchId);
      if (response.data) {
        debugger;
        const cleanedData = normalizeData( response.data.result[0]);
        setFormData(cleanedData);
        showToast("Employee data loaded.", 'success');
      } else {
        toast.error("Employee not found");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching employee");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      return;
    }

    try {
      setLoading(true);
      let res;
      if (searchId) {
        const updatedFormData = {
          ...formData,
          employeeid: searchId    // <-- Append employeeid explicitly
        };
        res = await EmployeeProcessService.setEmployeeData(updatedFormData);
       } //else {
      //   res = await EmployeeProcessService.setEmployeeData(formData);
      // }

      if (res.data.statusCode === 200) {
        showToast(searchId ? "Employee updated." : "Employee inserted.", 'success', { autoClose: 1500 });
        setFormData(initialFormState);
        setSearchId('');
      } else {
        toast.error("Error saving data");
      }
    } catch (err) {
      console.error(err);
      toast.error("Submission failed");
    } finally {
      setLoading(false);
    }
  };
  return (
    
    <>
    <div className="container mt-5">
      <h2 className="mb-4">Employee Form</h2>

      {/* 🔍 Search Box */}
      <div className="mb-4">
        <label className="form-label">Search by Employee ID</label>
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="Enter Employee ID"
            value={searchId}
            onChange={(e) => setSearchId(e.target.value)}
          />
          <button className="btn btn-secondary" onClick={handleSearch}>
            Search
          </button>
        </div>
      </div>

        <form onSubmit={handleSubmit}>
        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Company Name</label>
            <select name="companyName" className="form-select" onChange={handleChange} value={formData.companyName}>
              <option value="">Select Company</option>
              <option value="Company A">Company A</option>
              <option value="Company B">Company B</option>
            </select>
            <div className="text-danger">{errors.companyName}</div>
          </div>
          <div className="col-md-4">
            <label className="form-label">First Name</label>
            <input type="text" name="firstName" className="form-control" onChange={handleChange} value={formData.firstName} />
            <div className="text-danger">{errors.firstName}</div>
          </div>
          <div className="col-md-4">
            <label className="form-label">Middle Name</label>
            <input type="text" name="middleName" className="form-control" onChange={handleChange} value={formData.middleName} />
          </div>
        </div>

        <div className="row mb-3">
          
          <div className="col-md-4">
            <label className="form-label">Surname</label>
            <input type="text" name="surname" className="form-control" onChange={handleChange} value={formData.surname} />
          </div>
          <div className="col-md-4">
            <label className="form-label">Date of Joining</label>
            <input type="date" name="dateOfJoining" className="form-control" onChange={handleChange} value={formData.dateOfJoining} />
            <div className="text-danger">{errors.dateOfJoining}</div>
          </div>
          <div className="col-md-4">
            <label className="form-label">Date of Birth</label>
            <input type="date" name="dateOfBirth" className="form-control" onChange={handleChange} value={formData.dateOfBirth} />
            <div className="text-danger">{errors.dateOfBirth}</div>
          </div>
        </div>

        <div className="row mb-3">
        <div className="col-md-4">
            <label className="form-label">Employee Type</label>
            <select name="employeeType" className="form-select" onChange={handleChange} value={formData.employeeType}>
              <option value="">Select Type</option>
              <option value="Full-Time">Full-Time</option>
              <option value="Part-Time">Part-Time</option>
              <option value="Contract">Contract</option>
            </select>
            <div className="text-danger">{errors.employeeType}</div>
          </div>
          <div className="col-md-4">
            <label className="form-label">Branch</label>
            <select name="branch" className="form-select" onChange={handleChange} value={formData.branch}>
              <option value="">Select Branch</option>
              <option value="Branch A">Branch A</option>
              <option value="Branch B">Branch B</option>
            </select>
            <div className="text-danger">{errors.branch}</div>
          </div>
          <div className="col-md-4">
            <label className="form-label">Designation</label>
            <select name="designation" className="form-select" onChange={handleChange} value={formData.designation}>
              <option value="">Select Designation</option>
              <option value="Manager">Manager</option>
              <option value="Executive">Executive</option>
            </select>
            <div className="text-danger">{errors.designation}</div>
          </div>
        </div>

        <div className="row mb-3">
        <div className="col-md-4">
            <label className="form-label">Department</label>
            <select name="department" className="form-select" onChange={handleChange} value={formData.department}>
              <option value="">Select Department</option>
              <option value="HR">HR</option>
              <option value="IT">IT</option>
            </select>
            <div className="text-danger">{errors.department}</div>
          </div>
          <div className="col-md-4">
            <label className="form-label">Location</label>
            <select name="location" className="form-select" onChange={handleChange} value={formData.location}>
              <option value="">Select Location</option>
              <option value="Delhi">Delhi</option>
              <option value="Mumbai">Mumbai</option>
            </select>
            <div className="text-danger">{errors.location}</div>
          </div>
          <div className="col-md-4">
            <label className="form-label">Shift Time</label>
            <select name="shiftTime" className="form-select" onChange={handleChange} value={formData.shiftTime}>
              <option value="">Select Shift</option>
              <option value="Morning">Morning</option>
              <option value="Evening">Evening</option>
            </select>
            <div className="text-danger">{errors.shiftTime}</div>
          </div>
        </div>

        <div className="row mb-3">
        <div className="col-md-4">
            <label className="form-label">Probation</label>
            <select name="probation" className="form-select" onChange={handleChange} value={formData.probation}>
              <option value="">Select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <div className="text-danger">{errors.probation}</div>
          </div>
          <div className="col-md-4">
            <label className="form-label">Grade</label>
            <select name="grade" className="form-select" onChange={handleChange} value={formData.grade}>
              <option value="">Select Grade</option>
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
            </select>
            <div className="text-danger">{errors.grade}</div>
          </div>
          <div className="col-md-4">
            <label className="form-label">Aadhar Card No</label>
            <input type="text" name="aadharCardNo" className="form-control" onChange={handleChange} value={formData.aadharCardNo} />
            <div className="text-danger">{errors.aadharCardNo}</div>
          </div>
          
        </div>

        <div className="row mb-3">
        <div className="col-md-4">
            <label className="form-label">Aadhar Name</label>
            <input type="text" name="aadharName" className="form-control" onChange={handleChange} value={formData.aadharName} />
          </div>
          <div className="col-md-4">
            <label className="form-label">PAN Number</label>
            <input type="text" name="panNumber" className="form-control" onChange={handleChange} value={formData.panNumber} />
            <div className="text-danger">{errors.panNumber}</div>
          </div>
          <div className="col-md-4">
            <label className="form-label">Voter ID</label>
            <input type="text" name="voterId" className="form-control" onChange={handleChange} value={formData.voterId} />
          </div>
        </div>

        <div className="row mb-3">
          
          <div className="col-md-4">
            <label className="form-label">Mobile Number</label>
            <input type="text" name="mobileNumber" className="form-control" onChange={handleChange} value={formData.mobileNumber} />
            <div className="text-danger">{errors.mobileNumber}</div>
          </div>

          <div className="col-md-8">
          <label className="form-label">Address</label>
          <textarea name="address" className="form-control" rows="3" onChange={handleChange} value={formData.address}></textarea>
          <div className="text-danger">{errors.address}</div>
            </div>
        </div>

        <button type="submit" className="btn btn-primary" style={{textAlign:'center'}}>Submit</button> 
      </form>
      </div>
    </>
  )
}

export default EmployeeUpdate